/* eslint-disable prettier/prettier */
import React from 'react';
import withAppLayout from './components/withAppLayout';
import Routes from './routes';
const App: React.FC = () => {
  return (
    <div className='cmsApp'>
      <Routes />
    </div>
  );
};

export default withAppLayout(App);
